var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 428.346,
    height: 395.643,
    viewBox: "0 0 428.346 395.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10825",
    "data-name": "Rectangle 10825",
    width: 428.346,
    height: 395.643,
    transform: "translate(839.654 -31.875)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(-839.654 31.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4548",
    "data-name": "Mask Group 4548",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 2.205,
    y1: 10.546,
    transform: "translate(193.716 63.61)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 10.545,
    y2: 2.205,
    transform: "translate(199.307 52.862)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 2.204,
    y2: 10.545,
    transform: "translate(188.557 38.931)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y1: 2.204,
    x2: 10.546,
    transform: "translate(174.627 58.022)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y1: 3.072,
    x2: 2.01,
    transform: "translate(186.277 62.586)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 3.452,
    y1: 2.258,
    transform: "translate(198.281 60.497)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 2.01,
    y2: 3.072,
    transform: "translate(196.191 47.43)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 3.072,
    y2: 2.01,
    transform: "translate(183.125 50.582)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 10.342,
    x2: 3.017,
    transform: "translate(982.349 335.573)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 10.342,
    y1: 3.017,
    transform: "translate(994.319 330.664)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 3.017,
    y2: 10.342,
    transform: "translate(989.409 311.368)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 10.342,
    y2: 3.017,
    transform: "translate(970.114 323.603)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 1.765,
    x2: 3.219,
    transform: "translate(977.838 332.113)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 1.983,
    y1: 3.617,
    transform: "translate(990.859 334.972)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 3.219,
    y2: 1.765,
    transform: "translate(993.718 323.405)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 1.765,
    y2: 3.219,
    transform: "translate(982.151 319.092)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(26.888 22)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y1: 15.155,
    x2: 7.581,
    transform: "translate(19.316 196.583)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 15.155,
    y1: 7.581,
    transform: "translate(42.134 191.507)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 7.581,
    y2: 15.155,
    transform: "translate(37.059 161.115)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 15.155,
    y2: 7.581,
    transform: "translate(6.667 173.765)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 1.825,
    x2: 5.479,
    transform: "translate(15.726 190.016)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 2.051,
    y1: 6.156,
    transform: "translate(35.566 197.2)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 5.479,
    y2: 1.825,
    transform: "translate(42.751 181.012)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 1.825,
    y2: 5.479,
    transform: "translate(26.563 170.174)",
    fill: "none",
    stroke: "#f7c63c",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M89.488,34.147l4.545,14.265L108.677,45.3,94.412,49.842l3.115,14.644L92.982,50.221,78.338,53.336,92.6,48.791Z",
    fill: "#f7c63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M422.113,175.976l-9.472,18.279,17.255,11.23-18.279-9.472-11.23,17.254,9.472-18.279L392.6,183.759l18.279,9.472Z",
    transform: "translate(616.032)",
    fill: "#f7c63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M394.749,243.985l.827,9.648,9.682.129-9.647.827-.13,9.682-.827-9.648-9.682-.129,9.648-.827Z",
    transform: "translate(616.032)",
    fill: "#f7c63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M63.769,262.237l4.525,8.56,8.965-3.658-8.56,4.526,3.658,8.965-4.525-8.561-8.965,3.658,8.56-4.525Z",
    transform: "translate(365.028 -136.51)",
    fill: "#f7c63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M37.918,303.365,42.5,322.274,61.77,319.58l-18.909,4.583,2.694,19.268-4.583-18.908L21.7,327.217l18.909-4.583Z",
    transform: "translate(365.028 -136.51)",
    fill: "#f7c63c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M363.164,16.51s1.072-9.907,10.2-14.818l6.18,7.409s-9.671,1-12.894,9.781Z",
    transform: "translate(568.145 83)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M549.085,16.428s6.491-7.56,16.8-6.439l.9,9.6s-8.536-4.652-16.166.764Z",
    transform: "translate(616.032)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M205.873,215.254s-9.035-4.2-10.746-14.428l9-3.467s-2.169,9.478,5.111,15.356Z",
    transform: "translate(9.452 27)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M290.251,407.913s-9.035-4.2-10.746-14.428l9-3.467s-2.169,9.478,5.111,15.356Z",
    transform: "translate(486.032 -130.154)",
    fill: "#44abbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M259.274,5.4a34.26,34.26,0,0,1,8.01,15.175l5.506-1.237A65.79,65.79,0,0,0,266.032,0Z",
    transform: "translate(657.955 29.777)",
    fill: "#c3e254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M8.968,106.552a34.261,34.261,0,0,1,8.01,15.175l5.506-1.237a65.789,65.789,0,0,0-6.758-19.337Z",
    transform: "translate(6.731 4)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M155.414,19.694a34.267,34.267,0,0,1-12.85-11.372l-4.714,3.1A65.765,65.765,0,0,0,151,27.13Z",
    fill: "#ffd039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M599.985,138.028a34.267,34.267,0,0,1-12.85-11.372l-4.714,3.1a65.765,65.765,0,0,0,13.146,15.708Z",
    transform: "translate(616.032)",
    fill: "#ffd039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M29.216,388.938a34.264,34.264,0,0,1-12.85-11.373l-4.713,3.1A65.765,65.765,0,0,0,24.8,396.374Z",
    transform: "translate(315.028 -145.51)",
    fill: "#ffd039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M635.112,398.5a34.268,34.268,0,0,1-12.849-11.372l-4.715,3.1a65.766,65.766,0,0,0,13.146,15.708Z",
    transform: "translate(516.032 -210.608)",
    fill: "#44abbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M489.732,28.327a34.272,34.272,0,0,1,10.83-13.31l-3.293-4.582a65.776,65.776,0,0,0-15.15,13.786Z",
    transform: "translate(597.59 3.377)",
    fill: "#ffd039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M437.108,260.68a34.261,34.261,0,0,1,8.01,15.175l5.506-1.237a65.79,65.79,0,0,0-6.758-19.337Z",
    transform: "translate(616.032)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M427.848,359.453a34.272,34.272,0,0,1-6.128,16.028l4.56,3.323a65.781,65.781,0,0,0,10.083-17.83Z",
    transform: "translate(494.945 -183.477)",
    fill: "#c3e254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M643.453,13.812a34.272,34.272,0,0,1-6.128,16.028l4.56,3.323a65.782,65.782,0,0,0,10.083-17.83Z",
    transform: "translate(616.032)",
    fill: "#c3e254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M313.6,9.768,311.6,16.707l3.585,2.609,3.76-8.594Z",
    transform: "translate(712.007 40.583)",
    fill: "#f98732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M642.968,168.139l-1.994,6.939,3.585,2.609,3.76-8.594Z",
    transform: "translate(616.032)",
    fill: "#f98732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M15.083,265.568l-1.994,6.939,3.585,2.609,3.76-8.594Z",
    transform: "translate(365.028 -136.51)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M347.117,372.792l-1.994,6.939,3.585,2.609,3.76-8.594Z",
    transform: "translate(745.684 -85)",
    fill: "#f95850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M197.131,376.4l6.1,3.855,3.507-2.714-7.2-6.012Z",
    transform: "translate(365.028 -115.51)",
    fill: "#f98732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M214.62,319.094l-1.994,6.939,3.585,2.609,3.76-8.594Z",
    transform: "translate(365.028 -136.51)",
    fill: "#44abbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M3.62,5.876,0,18.471l6.509,4.736,6.824-15.6Z",
    fill: "#44abbc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.60ccc74db53c307ca9ce5a1513712d96.svg";
export { ForwardRef as ReactComponent };